import { AppBar, Toolbar } from '@mui/material'
import styled from 'styled-components'
import { COLORS } from 'utils'

const HeaderMenu = styled(AppBar)`
  color: ${COLORS.white};
  background: ${COLORS.lightGray};
  max-height: 66px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 0.6rem solid ${COLORS.tableColor};
`

const ToolbarMenu = styled(Toolbar)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const LogoContainer = styled.div`
  max-width: 115px;
`

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2.2rem;
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 5rem;
`

export {
  HeaderMenu,
  ToolbarMenu,
  LogoContainer,
  ActionsContainer,
  ContentContainer
}
